<template>

  <div class="grid-content bg-purple">


    <div class="grid-content bg-purple">
      <h2 style="float: left;">考核周期</h2>
      <el-button type="primary" @click="dialogexaminePeriodlist=true">添加考核周期</el-button>
      <div class="table-box">

        <el-table
          :data="examinePeriodlist"
          height="550"
          border
          style="width: 100%;">
          <el-table-column
            label="季度"
          >
            <template slot-scope="scope">
              {{scope.row.year}}年第({{scope.row.quarter}})季
            </template>
          </el-table-column>
          <el-table-column
            label="状态"
          >
            <template slot-scope="scope">
               <div v-if="scope.row.periodStatus ==1">开启</div>
              <div v-else>关闭</div>

            </template>
          </el-table-column>

          <el-table-column
            label="操作">
            <template slot-scope="scope">
              <el-button
              	type="success"
                size="mini"
                @click="opentPeriodtotal(scope.row.id)">编辑</el-button>
              <el-button
                size="mini"
                type="danger"
                @click="openDelete(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>

        </el-table>
      </div>
      <el-pagination
      	v-if="examinePeriodtotal>10"
        background
        layout="prev, pager, next"
        :page-size="examinePeriodpageSize"
        :total="examinePeriodtotal"
        @current-change="settexaminePeriod"
      >
      </el-pagination>
    </div>



    <el-dialog class="table-box"  :visible.sync="dialogexaminePeriodlist" :before-close="dialogrolupdatPeriodclose">

      <el-form ref="form" label-width="200px">

        <el-form-item label="季度：">
          <el-col :span="8" style="width: 160px;">
            <el-date-picker
              v-model="PeriodAdd.year"
              type="year"
              format="yyyy"
              value-format="yyyy"
              style="width: 160px"
              :picker-options="pickerOptionsadd"
              @change="pickerChangeFn"
              placeholder="请选择年份">
            </el-date-picker>
          </el-col>
          <el-col class="line" :span="2" style="line-height: 40px">-</el-col>
          <el-col :span="9">

            <el-select v-model="PeriodAdd.quarter" placeholder="请选择季度" style="float: left ;padding: 0px 0px 0px;" :clearable ="true">

              <el-option
                v-for="item in quarters"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>

          </el-col>
        </el-form-item >
        <el-form-item label="状态：">
          <el-radio v-model="PeriodAdd.periodStatus" :label="1" style="float: left;line-height: 41px;height: 41px;">开启</el-radio>
          <el-radio v-model="PeriodAdd.periodStatus" :label="2" style="float: left;line-height: 41px;height: 41px;">关闭</el-radio>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="examinePeriodAdd()">确认提交</el-button>

        </el-form-item>
      </el-form>

    </el-dialog>



    <el-dialog class="table-box" style="background: none;  " :modal="true" :visible.sync="dialogupdatPeriod" :before-close="dialogrolupdatPeriodclose">

      <el-form ref="form" label-width="200px">

        <el-form-item label="季度：">
          <el-col :span="9">
            <el-date-picker
              v-model="ExaminePeriod.year"
              type="year"
              style="width: 160px"
              format="yyyy"
              value-format="yyyy"
              :picker-options="pickerOptionsEnd"
              @change="pickerChangeFn"
              placeholder="请选择年份">
            </el-date-picker>
          </el-col>
          <el-col class="line" :span="2">-</el-col>
          <el-col :span="9">
            <el-select v-model="ExaminePeriod.quarter" placeholder="请选择季度" style="float: left ;padding: 0px 0px 0px;" :clearable ="true">

              <el-option
                v-for="item in quarters"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>


          </el-col>
        </el-form-item >
        <el-form-item label="状态：">
          <el-radio v-model="ExaminePeriod.periodStatus" :label="1" style="float: left;line-height: 41px;height: 41px;">开启</el-radio>
          <el-radio v-model="ExaminePeriod.periodStatus" :label="2" style="float: left;line-height: 41px;height: 41px;">关闭</el-radio>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="examinePeriodUpdate()">确认提交</el-button>

        </el-form-item>
      </el-form>

    </el-dialog>

  </div>
</template>

<script>
export default {
  name: "Cycle",
  data(){
    return {
      pickerOptionsadd: {
        disabledDate: time => {
          let beginDateVal = this.PeriodAdd.year
          // if (beginDateVal) {
          return (
            time.getTime() <
            new Date(beginDateVal).getTime() - 86400000 || time.getTime() > Date.now()
          )
          // }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.ExaminePeriod.year
          // if (beginDateVal) {
          return (
            time.getTime() <
            new Date(beginDateVal).getTime() - 86400000 || time.getTime() > Date.now()
          )
          // }
        }
      },
      quarters: [
        {   id:1,
          name: '第一季度',

        },
        {   id:2,
          name: '第二季度',

        },
        {
          id:3,
          name: '第三季度',
        },
        {
          id:4,
          name: '第四季度',
        },
      ],
      items: [
        {   id:1,
          type: 'success',
          code:'MT'
        },
        {   id:2,
          type: 'info',
          code:'HB'
        },
        {
          id:3,
          type: 'danger',
          code:'DD'
        },
      ],
      dialogexaminePeriodlist:false,
      examinePeriodlist:[],
      examinePeriodpageSize:10,
      examinePeriodtotal:0,
      examinePeriodpage:1,
      PeriodAdd:{
        year:'',
        quarter:'',
        periodStatus:1
      },
      Periodid:'',
      dialogupdatPeriod:false,
      ExaminePeriod:{
        year:'',
        quarter:'',
        periodStatus:1
      },
    }
  },
  beforeRouteEnter(to,from,next){

    next((vm)=>{

    });
  },
  created(){

  },
  mounted () {
    this.examinePeriodSelect();
  },
  methods: {
    pickerChangeFn(value){ // 日期选择器改变事件 ~ 解决日期选择器清空 值不清空的问题
      if(value===null){
        this.ExaminePeriod.year= value
        this.PeriodAdd.year = value
      }},

    dialogrolupdatPeriodclose(){
      this.ExaminePeriod={
        year:'',
        quarter:'',
        periodStatus:1
      };
      this.dialogupdatPeriod = false;

      this.PeriodAdd={
        year:'',
        quarter:'',
        periodStatus:1
      };
      this.dialogexaminePeriodlist =false;




    },
    examinePeriodSelect(){
      let that = this;
      let examinePeriodSelectdata={
         page:this.examinePeriodpage,
         pageSize:this.examinePeriodpageSize,
      }
      this.$axios
        .post('/api/examinePeriod/examinePeriodSelect',examinePeriodSelectdata)
        .then(function (res) {

            if(res.data.code==200) {
              that.examinePeriodlist = res.data.data.list
              that.examinePeriodtotal = res.data.data.total
            }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },
    settexaminePeriod(examinePeriodpage){
      this.examinePeriodpage = examinePeriodpage;
      this.examinePeriodSelect();
    },
    examinePeriodAdd(){
      let that = this;
      console.log()
      if (that.PeriodAdd.year == ''|| that.PeriodAdd.year == null) {
        that.$message.error('请选择年份');
        return false;
      }
      if (that.PeriodAdd.quarter == '') {
        that.$message.error('请输入季度');
        return false;
      }
      if (that.PeriodAdd.periodStatus == '') {
        that.$message.error('请选择考核状态');
        return false;
      }

      let examinePeriodAdddata={
        year:this.PeriodAdd.year,
        quarter:this.PeriodAdd.quarter,
       periodStatus:this.PeriodAdd.periodStatus
      }
      this.$axios
      .post('/api/examinePeriod/examinePeriodAdd',examinePeriodAdddata)
      .then(function (res){
        if(res.data.code==200){
          that.$message({
            message: '新增考核周期成功',
            type: 'success'
          });
          //  this.show == true;
          window.setTimeout(() => {
            location.reload();
          }, 1000);
        }else {
          that.$message.error("新增考核周期失败:"+res.data.msg);
        }
      }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });


    },
    opentPeriodtotal(Periodid){
        this.Periodid = Periodid;
      this.selectExaminePeriodById();
      window.setTimeout(() => {
        this.dialogupdatPeriod = true;
      },100);
    },
    selectExaminePeriodById(){
      let that = this;

      let selectExaminePerioddata = {
        id:this.Periodid
      }
      this.$axios
        .post('/api/examinePeriod/selectExaminePeriodById', selectExaminePerioddata)
        .then(function (res) {
          that.ExaminePeriod.year= ''+res.data.data.year;
          that.ExaminePeriod.quarter=res.data.data.quarter;
          that.ExaminePeriod.periodStatus=res.data.data.periodStatus;

        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },
    examinePeriodUpdate(){
      let that = this;

      if (that.ExaminePeriod.year == ''|| that.ExaminePeriod.year  == null) {
        that.$message.error('请选择年份');
        return false;
      }
      if (that.ExaminePeriod.quarter == '') {
        that.$message.error('请输入季度');
        return false;
      }
      if (that.ExaminePeriod.periodStatus == '') {
        that.$message.error('请选择考核状态');
        return false;
      }
      let ExaminePeriodUpdatedata={
        id:this.Periodid,
        year:this.ExaminePeriod.year,
        quarter:this.ExaminePeriod.quarter,
        periodStatus:this.ExaminePeriod.periodStatus
      }
      this.$axios
        .post('/api/examinePeriod/examinePeriodUpdate', ExaminePeriodUpdatedata)
        .then(function (res) {
          if(res.data.code==200){
            that.$message({
              message: '修改考核周期成功',
              type: 'success'
            });
            //  this.show == true;
            window.setTimeout(() => {
              location.reload();
            }, 1000);
          }else {
            that.$message.error("修改考核周期失败:"+res.data.msg);
          }

        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },


    openDelete(ExaminePeriodid) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.examinePeriodDelete(ExaminePeriodid)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    examinePeriodDelete(ExaminePeriodid){
      let that = this;
      let PeriodDeletedata={
        id:ExaminePeriodid,

      }
      this.$axios
        .post('/api/examinePeriod/examinePeriodDelete', PeriodDeletedata)
        .then(function (res) {
          if(res.data.code==200){
            that.$message({
              message: '删除考核周期成功',
              type: 'success'
            });
            //  this.show == true;
            window.setTimeout(() => {
              location.reload();
            }, 1000);
          }else {
            that.$message.error("删除考核周期失败:"+res.data.msg);
          }

        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });

    }



  },
  watch: {
    'ExaminePeriod.year'(val){
      this.ExaminePeriod.year = '' + val;
      }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/admin/Cycle.vue